import script from "./FormDropdownCurtain.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormDropdownCurtain.vue?vue&type=script&setup=true&lang=ts"

import "./FormDropdownCurtain.vue?vue&type=style&index=0&id=f4b10a3a&lang=scss"

const __exports__ = script;

export default __exports__